import { render } from "./PremiumCalculationBpmDetails.vue?vue&type=template&id=5521dbb4"
import script from "./PremiumCalculationBpmDetails.vue?vue&type=script&lang=js"
export * from "./PremiumCalculationBpmDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__